import * as React from "react";

import { cn } from "../lib/utils";

/**
 * shadcn `textarea` primitive (new-york). Sourced from the official registry and
 * matched to this repo's `input.tsx` style (a plain HTML element wrapper — the
 * CLI emits the same shape for textarea, no radix/per-package dependency). Used
 * by the tenant-admin policy editor for markdown authoring (06-09 / Surface 4).
 *
 * Shares the same focus-visible ring and `aria-invalid` destructive treatment as
 * `input.tsx` so validation styling is consistent across form controls.
 */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        // Atlas (09.3-05): rounded-field pair, hairline border, no shadow (C2), darker
        // --input surface in dark — matched to input.tsx for form-control consistency.
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input flex field-sizing-content min-h-16 w-full rounded-field border bg-transparent px-3 py-2 text-base transition-[color,box-shadow] duration-150 motion-reduce:transition-none outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
